import CrudService from './CrudService';

class CommonService extends CrudService {

	constructor() {
		super();
	}


	forgotPassword(email) {
		super.forgotPassword(email);
		/*return new Promise((resolve, reject) => {
			super.forgotPassword(email, (code, response) => {
				(code == 'success') ? resolve(response) : reject(response);
			});
		});*/
	}

	login(data) {
		return new Promise((resolve, reject) => {
			super.login(data, (code, response) => {
				(code === 'success') ? resolve(response) : reject(response);
			});
		});
	}

	resetPassword(password) {
		return new Promise((resolve, reject) => {
			super.resetPassword(password, (code, response) => {
				(code === 'success') ? resolve(response) : reject(response);
			});
		});
	}

	contact(data) {
		return new Promise((resolve, reject) => {
			super.contact(data, (code, response) => {
				(code === 'success') ? resolve(response) : reject(response);
			});
		});
	}

	findCustomer(code) {
		return new Promise((resolve, reject) => {
			super.customer(code, (code, response) => {
				(code === 'success') ? resolve(response) : reject(response);
			});
		});
	}

	findUser(code) {
		return new Promise((resolve, reject) => {
			super.findUser(code, (code, response) => {
				(code === 'success') ? resolve(response) : reject(response);
			});
		});
	}
}

const commonService = new CommonService();
export default commonService;



// WEBPACK FOOTER //
// ./src/opencell/services/CommonService.js